module.exports = __webpack_public_path__ + "static/media/preview.5e5cc0bf.svg";